import { combineReducers } from 'redux';

import loadingStateReducerFactory from '@nhl/loading-state-reducer-factory';
import actionTypes from './actionTypes';

/* State shape
{
    loadingState: {
        isLoading: bool,
        success: bool,
        error: Array
    },
    headshotsState: {
        selectedPlayers: Array,
    }
}
*/

const loadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_ZIP)(actionTypes.ZIP_RESPONSE);

const selectedPlayersReducer = (state = [], action) => {
    const { payload } = action;

    if (action.type === actionTypes.TOGGLE_PLAYERS) {
        if (!payload.isChecked) {
            return state.filter(id => !payload.playerIds.includes(id));
        } else {
            return state.concat(payload.playerIds.filter(playerId => !state.includes(playerId)));
        }
    }

    return state;
};

const headshotsStateReducer = combineReducers({
    selectedPlayers: selectedPlayersReducer
});


const reducer = combineReducers({
    headshotsState: headshotsStateReducer,
    loadingState: loadingStateReducer
});

export default reducer;